import React from "react";

export default function AuthPageShell({ children }) {
    return (
        <div className="blog-page-root">
            <div className="cms-page-inner auth-page-inner">
                <article className="cms-page-panel auth-page-panel">
                    {children}
                </article>
            </div>
        </div>
    );
}
